import AuthService from "./api/AuthService";

export const logout = async (userToken) => {
    try {
        const response = await AuthService.post('/auth/logout', '', {
            headers: {
                Authorization: 'Bearer ' + userToken
            }
        });

        return response.data;
    } catch {
        throw new Error("Ocorreu um erro ao efetuar LogOut");
    }
}

export default {
    logout
}